import { Input, TextArea } from "../../components/Form";
import { APP_LANGUAGES } from "../../utils/appLanguages";

const NotificationLanguageFields = ({
  values = {},
  onChange,
  error = {},
  titleKeyPrefix = "title",
  messageKeyPrefix = "message",
}) => (
  <>
    {APP_LANGUAGES.map(({ code, label }) => {
      const titleName = code === "en" ? "title" : `${titleKeyPrefix}${code.charAt(0).toUpperCase()}${code.slice(1)}`;
      const messageName = code === "en" ? "message" : `${messageKeyPrefix}${code.charAt(0).toUpperCase()}${code.slice(1)}`;
      return (
        <div key={code} className="col-12" style={{ marginBottom: 8 }}>
          <div style={{ fontWeight: 600, margin: "8px 0 4px", color: "#444" }}>
            {label}
            {code === "en" ? <span className="text-danger"> *</span> : " (optional, English is used if empty)"}
          </div>
          <div className="form-group mb-2">
            <Input
              type="text"
              name={titleName}
              value={values?.[titleName] || ""}
              onChange={onChange}
              placeholder={`${label} title`}
              className="form-control"
              label="Title"
            />
          </div>
          <div className="form-group mb-2">
            <TextArea
              type="text"
              name={messageName}
              value={values?.[messageName] || ""}
              required={code === "en"}
              onChange={onChange}
              placeholder={`${label} message`}
              className="form-control"
              label="Message"
              error={code === "en" && !values?.[messageName] ? error.message : ""}
            />
          </div>
        </div>
      );
    })}
  </>
);

export default NotificationLanguageFields;
